import { ref, computed } from 'vue'
import type { AiProposal } from '@/services/ai-generated/types'
import type { Video } from '@/services/videos/types'

export type AiVideoPrefetch = Video | AiProposal

const aiVideoPrefetch = ref<AiVideoPrefetch | null>(null)

function getVideoId(item: AiVideoPrefetch): string {
  return 'proposal_id' in item ? item.video.video_id : item.video_id
}

export function useSelectedAiVideo() {
  const aiVideoPrefetchId = computed(() =>
    aiVideoPrefetch.value ? getVideoId(aiVideoPrefetch.value) : null
  )

  function setAiVideoPrefetch(item: AiVideoPrefetch): void {
    aiVideoPrefetch.value = item
  }

  function consumeAiVideoPrefetch(videoId: string): AiVideoPrefetch | null {
    if (!aiVideoPrefetch.value || getVideoId(aiVideoPrefetch.value) !== videoId) {
      return null
    }
    return aiVideoPrefetch.value
  }

  function refreshAiVideoPrefetch(item: AiVideoPrefetch): void {
    if (aiVideoPrefetchId.value && getVideoId(item) === aiVideoPrefetchId.value) {
      aiVideoPrefetch.value = item
    }
  }

  function clearAiVideoPrefetch(): void {
    aiVideoPrefetch.value = null
  }

  return {
    aiVideoPrefetch,
    aiVideoPrefetchId,
    setAiVideoPrefetch,
    consumeAiVideoPrefetch,
    refreshAiVideoPrefetch,
    clearAiVideoPrefetch
  }
}
